module.exports = __webpack_public_path__ + "media/images/metronic/datatables/back_disabled-3d855354bf5bd7c8999ae017295b9608.png";